import { useEffect } from 'react';

const useHelmet = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default useHelmet;
